import * as e from "react";
import a from "../lib/IconBase.es.js";
import c from "../defs/TextB.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...t, weights: c }));
o.displayName = "TextBIcon";
const n = o;
export {
  n as TextB,
  o as TextBIcon,
  o as TextBolderIcon
};
